import { AfterViewInit, Directive, Host } from '@angular/core'
import { DatatableComponent, ColumnMode } from '@swimlane/ngx-datatable'

@Directive({
    selector: '[ngxColumnMode]',
})
export class NgxColumnModePipe implements AfterViewInit {
    constructor(@Host() private datatable: DatatableComponent) {
        this.datatable.columnMode = ColumnMode.flex
    }
    ngAfterViewInit(): void {
        this.datatable.columnMode = ColumnMode.force
    }
}
